<template>
    <div>
        <page :full-scroll="true">
            <div class="pt-3">
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <form-input label="Company" v-model="companyId" type="select" :options="companyOptions" :nocaps="true" />
                    </div>
                    <div class="col-12 col-md-6">
                        <form-input label="Match employees on" v-model="keyField" type="radio" :options="keyFieldOptions" helper-text="Download and import each file with the same setting." />
                    </div>
                </div>

                <div v-if="company">
                    <import-card
                        v-for="importType in importTypes"
                        :key="`${company.id}-${keyField}-${importType.kind}`"
                        :client="client"
                        :company="company"
                        :key-field="keyField"
                        :kind="importType.kind"
                        :title="importType.title"
                        :description="importType.description"
                    />
                </div>
            </div>
        </page>
    </div>
</template>

<script>
import Page from '@/components/Page'
import ImportCard from './components/ImportCard'

export default {
    components: {Page, ImportCard, },
    props: ['client', ],
    data() {
        return {
            companyId: this.client.companies.length == 1 ? this.client.companies[0].id : null,
            keyField: 'ssn',
            keyFieldOptions: [
                {text: 'SSN', value: 'ssn'},
                {text: 'Employee number', value: 'employee_number'},
            ],
            importTypes: [
                {
                    kind: 'employees',
                    title: 'Employees',
                    description: 'Employees, jobs and tax settings. Import these first.',
                },
                {
                    kind: 'direct-deposit',
                    title: 'Direct Deposit',
                    description: 'Bank accounts for employees that have already been imported.',
                },
                {
                    kind: 'priors',
                    title: 'Priors',
                    description: 'Prior paychecks for employees that have already been imported. Create benefit enrollments first so deductions can be linked to them.',
                },
            ],
        }
    },
    computed: {
        companyOptions() {
            return this.client.companies.map(c => ({text: `${c.company_code} - ${c.name}`, value: c.id}))
        },
        company() {
            return this.client.companies.find(c => c.id == this.companyId) || null
        },
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Imports')
    },
}
</script>
